type JSONValue = boolean | number | string | null | JSONArray | JSONObject

interface JSONArray extends Array<JSONValue> {}

interface JSONObject {
    [key: string]: JSONValue
}

const env = new Map<string, JSONValue>();

export default new Proxy(
    env,
    {
        get(target, property: string): JSONValue {
            if (!target.has(property)) {
                console.error(`Environment variable "${ property }" not available.`);
                return undefined;
            }
            return target.get(property);
        },
        set() {
            return false;
        },
    },
) as unknown as JSONObject;

export function load(config: JSONObject) {
    for (const key in config) {
        env.set(key, config[key]);
    }
}

const BUILT_IN_CONFIG = "FENV_CONFIG_PLACEHOLDER";
const B64_PLACEHOLDER = "RkVOVl9DT05GSUdfUExBQ0VIT0xERVI=";

try {
    if (BUILT_IN_CONFIG === atob(B64_PLACEHOLDER)) {
        console.warn("No built-in configuration available.");
    } else {
        load(JSON.parse(BUILT_IN_CONFIG));
    }
} catch (error) {
    console.error(error);
}
